Vue.component('battleQueue', {
  template: templates.battleQueue,
  data() {
    return {
      model: {
        battles: {},
        hasResults: false
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      battleService.getQueue()
        .then(function (response) {
          c.model.hasResults = true;
          for (let d of response.data) {
            d.queue = true;
            data[`${d.id}`] = d;
          }
          c.getTwitchName(data);
        })
        .catch(function (error) {
          c.model.hasResults = false;
          setTimeout(function() {
            c.get();
          }, 10000);
        });
    }, 
    getTwitchName(data, ids = [], results = []) {
      const c = this;
      let url = `${apiUrl}users?`;
      
      if (ids.length == 0) {
        for (let i in data) {
          let user1 = data[`${i}`].user1TwitchId;
          let user2 = data[`${i}`].user2TwitchId;
          if (user1 == null) {
            ids.push(data[`${i}`].user1TwitchId);
          } else {
            data[`${i}`].user1TwitchDisplayName = data[`${i}`].twitch1DisplayName;
          }

          if (user2 == null) {
            ids.push(data[`${i}`].user2TwitchId);
          } else {
            data[`${i}`].user2TwitchDisplayName = data[`${i}`].twitch2DisplayName;
          }
        }
      }

      for (let i = 0; i < 100; i++) {
        if (ids[i]) {
          url = `${url}id=${ids[i]}&`;
          ids.splice(i, 1);
        }
      }
      
      if (!ids.length) {
        c.model.battles = data;

        setTimeout(function() {
          c.get();
        }, 10000);
        
        return;
      }

      axios.get(url, {
          headers: { 
            'Client-ID': clientId,
            'Authorization': `Bearer ${utils.cookies.get('access_token')}` 
          }
        })
        .then(function (response) {
          results = results.concat(response.data.data);
          if (ids.length > 0) {
            c.getTwitchName(data, ids, results);
          } else {
            c.processTwitchNames(data, results);
          }
        })
        .catch(function (error) {
          if (error.response.status == 401) {
            authentication.refreshAccessToken({callback: function() {
              c.getTwitchName(data);
            }});
          }
        });
    },
    processTwitchNames(data, result) {
      const c = this;
      
      for (let d of result) {
        for (let i in data) {
          if (data[`${i}`].user1TwitchId == d.id) {
            data[`${i}`].user1TwitchDisplayName = d.display_name;
          } else if (data[`${i}`].user2TwitchId == d.id) {
            data[`${i}`].user2TwitchDisplayName = d.display_name;
          }
        }
      }
      c.model.battles = data

      setTimeout(function() {
        c.get();
      }, 10000);
    },
    start(id) {
      const c = this;
      battleService.save({id: id})
        .then(function (response) {
          c.model.battles[`${id}`].queue = false;
        })
        .catch(function (error) {
          //console.log(error);
        });
    }, 
    cancel(id) {
      const c = this;

      var result = confirm("Are you sure you want to remove this battle from the queue?");
      if (result == true) {
        battleService.cancel({id: id})
          .then(function (response) {
            c.model.battles[`${id}`].queue = false;
          })
          .catch(function (error) {
            //console.log(error);
          });
      }
    }
  }
});